const plugins = [
  'bootstrapVue',
  'crumbs',
  'filters',
  'sidebar',
  'veeValidate',
  'vueNotify'
]

plugins.forEach((file) => {
  require(`./${file}`)
})
